import { FC, Fragment, useLayoutEffect } from "react";
import styles from "./Location.module.scss";

export const Location: FC = () => {
  useLayoutEffect(() => {
    $("#map_canvas")
      .on("mouseenter", function () {
        $(".location-info").addClass("open");
      })
      .on("mouseleave", function () {
        $(".location-info").removeClass("open");
      });
  }, []);

  return (
    <Fragment>
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <h2 className="section-title">Location</h2>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-xl-10 offset-xl-1">
            <div className="map-info-container">
              <div
                className="info-wrapper"
                data-animation-direction="from-bottom"
                data-animation-delay="100"
              >
                <div className="location-info">
                  <div className="neela-style">
                    <h4
                      className="has-icon"
                      style={{ fontWeight: 100, minWidth: 250 }}
                    >
                      <i className="icon-champagne-glasses"></i>Cocktails
                      <small>04:00-05:00 PM</small>
                    </h4>

                    <div className="info-map-divider"></div>

                    <h4
                      className="has-icon"
                      style={{ fontWeight: 100, minWidth: 250 }}
                    >
                      <i className="icon-diamond-ring"></i>Ceremony
                      <small>05:00-05:30 PM</small>
                    </h4>

                    <div className="info-map-divider"></div>

                    <h4
                      className="has-icon"
                      style={{ fontWeight: 100, minWidth: 250 }}
                    >
                      <i className="icon-two-hearts"></i>
                      <span className={styles.label}>Reception</span>
                      <small style={{ display: "flex", alignItems: "center" }}>
                        06:00 PM -&nbsp;
                        <span
                          style={{
                            fontSize: 40,
                            fontWeight: 100,
                            lineHeight: "25.5px",
                          }}
                        >
                          ∞
                        </span>
                      </small>
                    </h4>
                  </div>
                </div>
              </div>

              <div
                className="map-wrapper"
                data-animation-direction="fade"
                data-animation-delay="100"
              >
                <div id="map_canvas" className="gmap"></div>

                <div className="map_pins">
                  <ul className="pins">
                    <li>
                      <i className="fas fa-glass-cheers"></i>Restaurant 1743
                      Cucina Italiana
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="center">
              <a href="#rsvp" className="btn btn-primary scrollto">
                <span className="h-lines"></span>
                <span className="v-lines"></span>
                RSVP
              </a>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
